<template>
    <ExternalLink 
        :link=ctaLink
        class="btn-orange-outlined PrimairyCTA"
    >
        <div class="flex-grid justify-space-between">
            <div>
                <h3>{{ctaTitle}}</h3>
                <h4 class="noMargin ">{{ctasubTitle}}</h4>
            </div>
            <span class="align-self">></span>
        </div>
    </ExternalLink>
  </template>
  

<script>
import ExternalLink from '@/components/ComponentExternalLink.vue';

export default {
name: "PrimairyCTA",
components: {
    ExternalLink
  },
props: {
    ctaLink: {
        type: String,
        required: false
    },
    ctaTitle: {
        type: String,
        required: false
    },
    ctasubTitle: {
        type: String,
        required: false
    }
}
};
</script>

<style scoped>
.PrimairyCTA {
    min-width: 30%;
    border-left: 8px solid rgba(245, 166, 35, 1);
    background-color: white;
    margin: 64px 16px 64px 16px;
    padding: 16px;
    opacity: 1; /* Fully opaque */
}
.PrimairyCTA:hover {
    color: white;
    background: rgba(245, 166, 35, 1);
}
.PrimairyCTA:last-child {
    color: black;    
}
.noMargin {
    margin: 0;
}
@media (min-width: 240px) and (max-width: 720px) {
    .PrimairyCTA {
        width: 100%;
        margin: 0 0 4px 0;
        transform: translateY(-50%); /* Lift it 20px upwards */
        z-index: 1;           /* Ensure it's on top of the first div */
    }
    h3 {
        font-size: 16px;
        margin: 0;
    }
    h4 {
        font-size: 12px;
        margin: 0;
    }
}

</style>
